import { NavLink } from "react-router-dom";
import { useLogSheet } from "../../contexts/LogSheetContext";
import "./BottomNav.css";

const ICONS = {
  today: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 11l9-8 9 8" />
      <path d="M5 10v10h14V10" />
    </svg>
  ),
  trips: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="7" width="18" height="13" rx="2" />
      <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </svg>
  ),
  log: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  journey: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" />
      <line x1="9" y1="3" x2="9" y2="18" />
      <line x1="15" y1="6" x2="15" y2="21" />
    </svg>
  ),
  people: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
      <path d="M16 5.5a3 3 0 0 1 0 5M18 20c0-2.2-.9-4.2-2.3-5.6" />
    </svg>
  ),
} as const;

interface NavItem {
  to: string;
  label: string;
  icon: keyof typeof ICONS;
  end?: boolean;
}

const LEFT: NavItem[] = [
  { to: "/", label: "Today", icon: "today", end: true },
  { to: "/trips", label: "Trips", icon: "trips" },
];

const RIGHT: NavItem[] = [
  { to: "/journey", label: "Journey", icon: "journey" },
  { to: "/connections", label: "People", icon: "people" },
];

export function BottomNav() {
  const { openLogSheet } = useLogSheet();

  return (
    <nav className="bnav" aria-label="Primary">
      {LEFT.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) => `ni${isActive ? " on" : ""}`}
        >
          <span className="ni-icon">{ICONS[item.icon]}</span>
          <span className="ni-label">{item.label}</span>
        </NavLink>
      ))}

      <button type="button" className="ni log" onClick={openLogSheet} aria-label="Log activity">
        <span className="fab">{ICONS.log}</span>
        <span className="ni-label">Log</span>
      </button>

      {RIGHT.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) => `ni${isActive ? " on" : ""}`}
        >
          <span className="ni-icon">{ICONS[item.icon]}</span>
          <span className="ni-label">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
